<template>
  <iiframe
    v-if="rollSrc && rollSrc.length > 5 && $store.state.show.frame && $store.state.show.frame[rollSrc]"
    :appsrc="rollSrc"
    class="fill flexw"
  ></iiframe>
  <div v-else class="fill align-center">
    <div class="md-font flex column fill-h">
      <div class="p4 flex align-center label fit" @click="show = {}" style="position: fixed">
        <img src="/img/icons/favicon-32x32.png" alt style="height: 24px; width: 24px;">
        <span>XMBL</span>
      </div>
      <div class="text-shadow white flex column center align-center fill-h">
        <div class="text-glow p32">
          <div
            :class="$store.state.device.mobile ? 'xl-font': 'xxl-font'"
          >Power to the People</div>
          <b
            class="text-glow p4"
            :class="$store.state.device.mobile ? 'md-font': 'lg-font'"
          >Build decentralized applications (dApps) on blockchain economics. No coding required.</b>
        </div>
        <ul class="flex p4 wrap around container">
          <li
            class="text-shadow sub-container flexz center"
            :class="$store.state.device.mobile ? 'fill' : 'fit'"
            v-for="(step, stepKey) in features"
            :key="stepKey"
            style="background: rgba(0,0,0,.3); min-width: 270px;"
          >
            <div class="p8">
              <b
                @click="show = {}; $set(show, stepKey, !show[stepKey])"
                class="lg-font flex align-center center text-glow"
                :class="$store.state.device.mobile ? 'p4' : 'p16'"
              >
                <i class="r4 fa-2x" :class="step.color + '-text' + ' ' + step.icon"></i> {{step.name}}
              </b>
              <p
                v-if="show[stepKey] || !$store.state.device.mobile"
                class="md-font flex column center align-center fit"
                :class="$store.state.device.mobile ? 'p4' : 'p16'"
              >
                <span class="p4">{{step.msg}}</span>
                <span>{{step.more}}</span>
              </p>
            </div>
            <div v-if="step.name === 'dApps'" :class="$store.state.device.mobile ? 'p4' : 'p16'">
              <button
                v-if="!show.action"
                type="button"
                @click="show = {}; $set(show, 'action', true)"
                class="update lg-font fill"
                :class="$store.state.device.mobile ? 'p4' : 'p16'"
                style="max-width: 480px"
              >
                <i class="fas fa-rocket p4"></i> Build App
              </button>
              <div
                v-if="show.action"
                class="flex align-center wrap sub-container p4 fill"
                style="background: rgba(0,0,0,.4); max-width: 540px"
              >
                <div class="flex align-center around fill p4">
                  <input
                    autofocus="true"
                    id="rollyourown"
                    class="p4 flexy r4 flex"
                    v-model="rollYourOwn"
                    type="text"
                    placeholder="Application Name"
                  >
                  <a class="lg-font flex">
                    <button
                      @click.prevent="rollSrc = 'https://' + rollYourOwn.replace(/ /g, '-') + '.XMBL.dev'; $set($store.state.show.frame, rollSrc, true); scrollUp();"
                      :disabled="!rollYourOwn"
                      type="button"
                      class="flex center align-center update p4"
                    >
                      <i class="fas fa-rocket p4"></i>
                    </button>
                  </a>
                </div>
              </div>
            </div>
            <div v-if="step.name === 'Blockchain'" :class="$store.state.device.mobile ? 'p4' : 'p16'">
              <button
                type="button"
                class="lg-font fill success"
                :class="$store.state.device.mobile ? 'p4' : 'p16'"
                style="max-width: 480px"
                >
                  <i class="fas fa-coins p4"></i> Get Tokens
              </button>
            </div>
            <div v-if="step.name === 'Basic Income'" :class="$store.state.device.mobile ? 'p4' : 'p16'">
              <a target="new" href="https://docs.google.com/document/d/1nIZUsgTqWrfhNDumPuBdhR3rySVfxq4g6vdSChfffI4/edit?usp=drive_web&ouid=117801958411888638030">
                <button
                  type="button"
                  class="lg-font fill indicate"
                  :class="$store.state.device.mobile ? 'p4' : 'p16'"
                  style="max-width: 480px"
                  >
                    <i class="fas fa-scroll p4"></i> Read Whitepaper
                </button>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "hello",
  data() {
    return {
      action: false,
      features: [
        {
          name: "dApps",
          msg:
            "Create shops and social networks. It's your data, decentralized and free. Say goodbye to developers and hello to your community.",
          icon: "fas fa-project-diagram",
          color: 'update'

        },
        {
          name: "Blockchain",
          msg:
            "Transact confidently using our level-3 blockchain system. XMBL uses Bitcoin Network for settlements and Lightning Network for speed.",
          icon: "fas fa-cubes",
          color: 'success'
        },
        {
          name: 'Basic Income',
          msg:
            "3% of XYM Token activation cost is distributed to all token holders. Particiate in Social Security v2.0 and help UBI become real.",
          icon: "fas fa-balance-scale",
          color: 'indicate'
        }
      ],
      rollYourOwn: "",
      rollSrc: "",
      show: {},
      showError: false
    };
  },
  methods: {
    scrollUp() {
      return window.scrollTo(0, 0);
    }
  }
};
</script>